<template>
  <div class="download-wrapper">
    <div class="download-logo">
      <img
        :src="icons.Connect_App"
        alt="logo-life">
    </div>
    <div class="download-text">
      <p>{{ $t('downloadText') }}</p>
      <p>{{ $t('downloadMoreText') }}</p>
    </div>
    <div
      class="download-btn"
      @click="download">
      <p>{{ $t('downloadBtn') }}</p>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import { Connect_App } from '@/images'
import shareText from '@/config/share'
export default {
  data () {
    return {
      icons: {
        Connect_App
      }
    }
  },
  methods: {
    download () {
      window.open(shareText.app_download, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.download-wrapper {
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  max-width: 375px;
  height: 90px;
  padding: 15px;
  border-radius: 12px 12px 0 0;
  background: $color-primary;
  .download-logo {
    img {
      width: 60px;
      height: 60px;
    }
  }
  .download-text {
    flex: 1;
    margin: 0 15px;
    p {
      @include font-Medium;

      color: $color-bg-white;
      font-size: $base-font-size;
      line-height: 22px;
    }
  }
  .download-btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 25px;
    padding: 4px 15px;
    border-radius: 4px;
    background: $color-bg-white;
    p {
      @include font-Medium;

      color: $color-primary;
      font-size: $little-font-size;
      line-height: 18px;
    }
  }
}
</style>
